import { render, staticRenderFns } from "./addMyVisitSuccess.vue?vue&type=template&id=5656722c&scoped=true"
import script from "./addMyVisitSuccess.vue?vue&type=script&lang=js"
export * from "./addMyVisitSuccess.vue?vue&type=script&lang=js"
import style0 from "./addMyVisitSuccess.vue?vue&type=style&index=0&id=5656722c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656722c",
  null
  
)

export default component.exports